import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  gap: "10px",
  backgroundColor: theme.palette.background.default,

  "& > .MuiPagination-root": {
    alignSelf: "flex-end",
  },
}));
